export default "__VITE_ASSET__$2S7pXtt__"